import { Expose } from 'class-transformer';
import { Model } from './model';

export class EnthusiastsStatisticsStudentModel extends Model {
  @Expose() id: string;
  @Expose() studentName: string;
  @Expose() totalPages: number;
}
